// Donation prompt component logic

$('.donate-button').click(function (e) {
    let $payInLink = $(this);
    let $frm = $payInLink.parents('form');
    let $activePane = $('.donation-type-pane.uk-active', $frm);
    // single or regular?
    let donationType = $activePane.data('donation-type');
    // donation amount?
    let donationAmount = $('li.uk-active a', $activePane).data('amount');
    if (donationAmount === undefined) {
        // other amount
        donationAmount = $('li.other-amount input', $activePane).val();
    }

    // replace link placeholders
    // - get the href
    let payInLinkHref = $payInLink.data('href');
    // - replace donation type in href
    payInLinkHref = payInLinkHref.replace('<single_or_regular>', donationType);
    // - replace donation amount in href
    payInLinkHref = payInLinkHref.replace('<donation_amount>', donationAmount);
    // - do the replacement in the link
    $payInLink.attr('href', payInLinkHref);
});

$(document).ready(function () {
    // Other amount input mask
    $('.other-amount input').inputmask({ placeholder: "" });
    // deselect default amounts when other amount is selected
    $('.amounts input[type=tel]').click(function () {
        const $t = $(this);
        const sw = $t.parents('.donation-type-pane')
            .find('.uk-switcher')
            .first();
        UIkit.switcher(sw).show(3);
        $t.parents('ul').find('.uk-active').removeClass('uk-active');
        $t.parents('li').addClass('uk-active');
    });
    // set other amount when a default amount is selected
    $('.amounts li:not(.other-amount)').click(function () {
        const $t = $(this);
        $t.parents('ul').find('input').val($('a', $t).data('amount'));
    });

});